import get from "./get"
import set from "./set"
import update from "./update"
import adb from "./adb"
import fidelio from "./fidelio"

class Api {
  constructor() {
    this.get = get
    this.set = set
    this.update = update
    this.adb = adb
    this.fidelio = fidelio
  }
}

export default new Api()
